import { Injectable } from '@angular/core';



@Injectable()
export class ConstantsService {


  public _months = [{ id: 1, name: 'Janeiro' },
  { id: 2, name: 'Fevereiro' },
  { id: 3, name: 'Março' },
  { id: 4, name: 'Abril' },
  { id: 5, name: 'Maio' },
  { id: 6, name: 'Junho' },
  { id: 7, name: 'Julho' },
  { id: 8, name: 'Agosto' },
  { id: 9, name: 'Setembro' },
  { id: 10, name: 'Outubro' },
  { id: 11, name: 'Novembro' },
  { id: 12, name: 'Dezembro' },
  ];



  getMonths() {
    return this._months;
  }


  getYears() {
    let years = [];

    for (let i = 2000; i <= 2030; i++) {
      years.push({ id: i, name: i.toString() });
    }

    return years;

  }

  getCompanies() {
    return [{ id: -1, name: 'Todas' },
    { id: 1, name: 'Spolti Technologies' },
    { id: 2, name: 'Intellitools' },];
  }





}
